import { render } from "./CarId.vue?vue&type=template&id=3208ad88&scoped=true&ts=true"
import script from "./CarId.vue?vue&type=script&lang=ts"
export * from "./CarId.vue?vue&type=script&lang=ts"

import "./CarId.vue?vue&type=style&index=0&id=3208ad88&lang=scss&scoped=true"

import exportComponent from "/builds/spark/services/frontend/admin-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3208ad88"]])

export default __exports__